import { Switch } from '@/components/form/baseInputs/Switch';

interface PreviewWithBrandingToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export function PreviewWithBrandingToggle({
  checked,
  onChange,
}: PreviewWithBrandingToggleProps) {
  return (
    <Switch
      label="Preview in brand style"
      labelPosition="right"
      value={checked}
      onChange={(e) => onChange(e.target.checked)}
      name="previewWithBranding"
    />
  );
}
